import { useMemo } from 'react';
import type { IRecordListModel, IRecordListParams } from '@platform/core/types';

/**
 * Відбір записів списку (model.query: фільтр, пресет, пошук) для подань, що вантажать дані самі (панель показників, календар, аналітичні
 * подання): той самий об'єкт між рендерами, доки відбір не змінився (стабільний аргумент запитів RTK). Без запиту моделі — порожній відбір.
 */
export function useListParams(model: IRecordListModel): IRecordListParams {
  const filter = model.query?.filter;
  const preset = model.query?.preset;
  const q = model.query?.q;
  return useMemo(() => ({ ...(filter ? { filter } : {}), ...(preset ? { preset } : {}), ...(q ? { q } : {}) }), [filter, preset, q]);
}
